import React from "react";
import { connect } from "react-redux";
import {
  getSpeakerContactFirstLastNameFields,
  getSelectedSpeakerContactValues,
  getSelectedSpeakerEmailError
} from "../selectors";
import { actions, getters } from "Portal/CallForPapersForm/model";
import Field from "./Field";
import { noop } from "utils/General";

const decorate = connect(
  state => ({
    contactValues: getSelectedSpeakerContactValues(state),
    emailError: getSelectedSpeakerEmailError(state),
    firstLastNameFields: getSpeakerContactFirstLastNameFields(state),
    selectedSpeakerId: getters.selectedSpeakerId(state)
  }),
  {
    updateContactValues: actions.updateSpeakerContactValues,
    verifySpeakerEmail: actions.verifySpeakerEmail
  }
);

const ContactEmailField = ({
  updateContactValues = noop,
  contactValues = [],
  firstLastNameFields = "",
  emailError = "",
  verifySpeakerEmail = noop,
  selectedSpeakerId
}) => {
  return (
    <Field
      field={firstLastNameFields[2]}
      values={contactValues}
      updateValues={data => updateContactValues(data)}
      onFieldBlur={() => {
        verifySpeakerEmail(selectedSpeakerId);
      }}
      emailError={emailError}
    />
  );
};

export default decorate(ContactEmailField);
